import { render, staticRenderFns } from "./Reset.vue?vue&type=template&id=3ab79d6d&scoped=true"
import script from "./Reset.vue?vue&type=script&lang=js"
export * from "./Reset.vue?vue&type=script&lang=js"
import style0 from "./Reset.vue?vue&type=style&index=0&id=3ab79d6d&prod&scoped=true&lang=css"
import style1 from "./Reset.vue?vue&type=style&index=1&id=3ab79d6d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab79d6d",
  null
  
)

export default component.exports